import { render, staticRenderFns } from "./FormGeneratorItems.vue?vue&type=template&id=2f90016d&scoped=true"
import script from "./FormGeneratorItems.vue?vue&type=script&lang=js"
export * from "./FormGeneratorItems.vue?vue&type=script&lang=js"
import style0 from "./FormGeneratorItems.vue?vue&type=style&index=0&id=2f90016d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f90016d",
  null
  
)

export default component.exports